import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'vuln_filters';

const defaults = { customerId: '', assetGroupId: '' };

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...defaults };
    return { ...defaults, ...JSON.parse(raw) };
  } catch {
    return { ...defaults };
  }
}

function save(filters) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
}

export default function useVulnFilters() {
  const [filters, setFilters] = useState(load);

  useEffect(() => {
    save(filters);
  }, [filters]);

  const setCustomerId = useCallback((id) => {
    setFilters((prev) => ({ ...prev, customerId: id, assetGroupId: '' }));
  }, []);

  const setAssetGroupId = useCallback((id) => {
    setFilters((prev) => ({ ...prev, assetGroupId: id }));
  }, []);

  const clearAll = useCallback(() => {
    setFilters({ ...defaults });
  }, []);

  return {
    customerId: filters.customerId,
    assetGroupId: filters.assetGroupId,
    setCustomerId,
    setAssetGroupId,
    clearAll,
  };
}
